import { useEffect, useState } from "react";
import ButtonIconH from "./ButtonIconH";
import { userData, inputOnEnter } from "../js/utils";
import { post } from "../js/post";
import moment from "moment";
import DataTable from "react-data-table-component";
import { DashboardPatientStatsPopup } from "./DashboardPatientStatsPopup";
import {
  existingPatientDashboardBrandTable,
  patientDashboardBrandTable,
} from "../js/tableColumns";

export function DashboardPatientStatsPanel() {
  moment.locale("es");
  const [searchYear, setSearchYear] = useState(moment());
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [graphicPanel, setGraphicPanel] = useState(false);
  const [statsData, setStatsData] = useState(null);

  const getClientStatisticsDashboard = async () => {
    const response = await post(
      "support-extra/dashboard/ObtenerEstadisticasClientesDashboard.php",
      {
        token: userData.token,
        ano: searchYear.year(),
        fechaDesde: startDate,
        fechaHasta: endDate,
      },
    );
    setStatsData(response);
  };

  const clearFilters = () => {
    setSearchYear(moment());
    setStartDate("");
    setEndDate("");
  };

  useEffect(() => {
    getClientStatisticsDashboard();
  }, [searchYear, startDate, endDate]);

  return (
    <div>
      <DashboardPatientStatsPopup
        show={graphicPanel}
        onClose={() => {
          setGraphicPanel(false);
        }}
      />
      <div className="opt-table-content grid-13" id="dashboard-patient-stats">
        <div className="cell cell-start-content">Año</div>
        <div className="cell">
          <div className="data-field">
            <button
              className="incdec-btn"
              onClick={() => {
                setSearchYear((prev) => moment(prev).subtract(1, "year"));
              }}
            >
              {"<"}
            </button>
            <span style={{ width: "35px", textAlign: "center" }}>
              {moment(searchYear).year()}
            </span>
            <button
              className="incdec-btn"
              onClick={() => {
                setSearchYear((prev) => moment(prev).add(1, "year"));
              }}
            >
              {">"}
            </button>
          </div>
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">Fecha desde</div>
        <div className="cell">
          <input
            type="date"
            max="9999-12-31"
            tabIndex={0}
            className="input-field"
            value={startDate}
            onChange={(e) => {
              setStartDate(e.target.value);
            }}
            onKeyUp={(e) => inputOnEnter(e)}
          ></input>
        </div>
        <div className="cell"></div>
        <div className="cell cell-start-content">Fecha hasta</div>
        <div className="cell">
          <input
            type="date"
            max="9999-12-31"
            tabIndex={0}
            className="input-field"
            value={endDate}
            onChange={(e) => {
              setEndDate(e.target.value);
            }}
            onKeyUp={(e) => inputOnEnter(e)}
          ></input>
        </div>
        <div className="cell">
          <button className="cell-label" onClick={clearFilters} tabIndex={-1}>
            Limpiar filtros
          </button>
        </div>
        <div className="cell combined-cells-4 cell-end-content">
          <ButtonIconH
            text="Gráficos"
            small={true}
            onClick={() => {
              setGraphicPanel(true);
            }}
          ></ButtonIconH>
        </div>
      </div>
      <div style={{ marginTop: 20, marginBottom: 20 }}>
        {statsData !== null && (
          <>
            <div className="opt-table-title">
              Tabla de actividad de pacientes nuevos
            </div>
            <DataTable
              columns={patientDashboardBrandTable}
              data={statsData.pacientesNuevos.slice(0, -1)}
              className="custom-datatable custom-dt-patient-stats dashboard-custom-table non-interactive"
              noDataComponent="No hay datos disponibles."
            />
            {statsData.pacientesNuevos.length > 0 && (
              <DataTable
                columns={patientDashboardBrandTable}
                data={statsData.pacientesNuevos.slice(-1)}
                className="custom-datatable summary-row no-header-datatable"
              />
            )}
          </>
        )}
        {statsData !== null && (
          <div style={{ marginTop: 30 }}>
            <div className="opt-table-title">
              Tabla de actividad de pacientes existentes
            </div>
            <DataTable
              columns={existingPatientDashboardBrandTable}
              data={statsData.pacientesExistentes.slice(0, -1)}
              className="custom-datatable custom-dt-patient-stats dashboard-custom-table non-interactive"
              noDataComponent="No hay datos disponibles."
            />
            {statsData.pacientesExistentes.length > 0 && (
              <DataTable
                columns={existingPatientDashboardBrandTable}
                data={statsData.pacientesExistentes.slice(-1)}
                className="custom-datatable summary-row no-header-datatable"
              />
            )}
          </div>
        )}
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <ButtonIconH
          text={"Exportar"}
          small={true}
          onClick={() => {}}
        ></ButtonIconH>
      </div>
    </div>
  );
}
